export function addDays(date: Date, days: number): Date {
  date.setDate(date.getDate() + days);
  return date;
}

export function toIsoDate(value: Date): number {
  const d: Date = new Date(value);
  let month: string = '' + (d.getMonth() + 1);
  let day: string = '' + d.getDate();
  const year: string = '' + d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return Number(year + month + day);
}

export function toIso8601Date(value: Date | null | undefined): string {
  if (value === undefined || value === null) {
    return '';
  }
  const d: Date = new Date(value);
  let month: string = '' + (d.getMonth() + 1);
  let day: string = '' + d.getDate();
  const year: string = '' + d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return String(year + '-' + month + '-' + day);
}

export function dateCompare(d1: Date, d2: Date): number {
  if (d1 > d2) {
    return 1;
  }
  if (d1 < d2) {
    return -1;
  }
  return 0;
}

export function getWeek(date: Date): number {
  // Get the week number of the year for the passed in date
  // https://stackoverflow.com/a/6117889/281130
  // Copy date so don't modify original
  date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  // Get first day of year
  const yearStart: Date = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  const msDiff: number = date.getTime() - yearStart.getTime();
  const weekNo: number = Math.ceil((msDiff / 86400000 + 1) / 7);
  return weekNo;
}
